<template>
  <div class="user-head">

    <!-- 顶部 -->
    <div class="width100 float_l img_backg1">
        <div class="width100 float_l height80 line_hei80">
            <!-- 顶部左边 -->
            <div class="float_l">
                <div class="float_l margin_l20 logo">
                    后台系统
                </div>
                <div class="float_l">
                    <ul class="ul_li fon_siz16">
                        <li>
                          <a href="/#/">首页</a>
                        </li>
                        <li>
                          <a href="/#/noticesList">系统公告</a>
                        </li>
                        <li>
                          <a href="/#/laboratoryList">实验室列表</a>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- 顶部右边 -->
            <div class="float_r">
                <div class="float_l top_input">
                    <input class="posi_relative" type="text" name="" id="" v-model="txt1" placeholder="请输入想搜索的内容...">
                    <span @click="search()"><img class="img_sousuo bianshou" src="img/uiz4.png"></span>
                </div>
                <div class="float_l margin_l40">
                    <a :href="goNiticeUrl"><img src="img/uiz3.png"></a>
                </div>
                <div class="float_l margin_l35">
                    <a :href="goMessageUrl"><img src="img/uiz6.png"></a>
                </div>
                <div class="float_l margin_l30 margin_r40">
                    <a :href="goUserUrl">
                      <img src="img/uiz2.png" v-if="!headPic">
                      <img :src="headPic"  v-if="headPic" style="width:32px;height:32px; border-radius:50%;" />
                    </a>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    name :'user-head',
    data(){
      return {
        docWidth:document.documentElement.clientWidth,
        docHeight:document.documentElement.clientHeight,
        userId : 0,
        isCanAuthor : 0,
        isAuthor : 0,
        headPic: '/headpic.jpg',
        dataJson:{
          userName: "请登录"
        },
        txt1 : this.$route.query.key?this.$route.query.key:"",
        goUserUrl : '/#/login',
        goNiticeUrl: '',
        goMessageUrl: ''
      }
    },
    mounted(){      
      let userId = this.getCookie("userId")
      let loginType = this.getCookie("loginType")
      if(loginType == "1"){
        this.userId = userId
        if(this.userId>0){
          this.getData()
        }
        this.goUserUrl = "/#/user/StudentsEdit"
        this.goNiticeUrl = '/#/user/FanKuisList'
        this.goMessageUrl = '/#/user/MessagesList'
      }else if(loginType == '2'){
        this.userId = userId
        if(this.userId>0){
          this.getTeacherData()
        }
        this.goUserUrl = "/#/teacher/TeachersEdit"
        this.goNiticeUrl = '/#/teacher/NoticesList'
        this.goMessageUrl = '/#/teacher/MessagesList'
      }
    },
    methods: {
      search:function(){
        window.location.href = '/#/laboratoryList?key='+this.txt1+'&r='+ Math.random();
      },
      getData:function(){
        const ths = this;
        
        this.$get('/Students/GetById?StudentId='+ths.userId)
          .then(function (res) { 
              console.log(res)
              if(res.ok){
                ths.dataJson = res.data
              }
              else{
              }  
          })
          .catch(function (err) {
            console.log(err)
          })  
      },
      getTeacherData:function(){
        const ths = this;
        
        this.$get('/Teachers/GetById?Id='+ths.userId)
          .then(function (res) { 
              console.log(res)
              if(res.ok){
                ths.dataJson = res.data
              }
              else{
              }  
          })
          .catch(function (err) {
            console.log(err)
          })  
      },
      // 获取cookie
      getCookie: function (key) {
          return window.localStorage.getItem(key);
      },
    }
  }
</script>

<style>
  html body{
    background: white;
  }
  *{
    margin:0;
    padding:0;
  }
  .page-content{
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    float: none!important;
  }
  .user-head{
    overflow:hidden;
  }
  .main-content{
  }

</style>